import React from 'react';
import { MedicationRequestOutputDto } from 'graphql/generated/remote-schema-hasura';
import { formatFullScriptDuration } from '../../../../../../../utilities/formatFullScriptDuration';
import { capitalizeFirstLetter } from '../../../../../../../utilities/functions';

const MedicationRow: React.FC<MedicationRequestOutputDto> = ({
  displayName,
  dosage,
  frequency,
  duration,
  takeWith,
  productNotes,
}) => {
  return (
    <div className="hidden desktop:grid gap-2.5 border border-transparent border-t-gray-opacity-15 grid-cols-12 w-full px-30 py-2.5 text-med-gray-3 text-base font-medium">
      <div className="col-span-2">
        <p className="text-neutral-800">{displayName}</p>
      </div>
      <div className="col-span-2">{dosage || '-'}</div>
      <div className="col-span-2">
        {capitalizeFirstLetter(frequency) || '-'}
      </div>
      <div className="col-span-2">
        {formatFullScriptDuration(duration) || '-'}
      </div>
      <div className="col-span-2">{capitalizeFirstLetter(takeWith) || '-'}</div>
      <div className="col-span-2">{productNotes || '-'}</div>
    </div>
  );
};

export default MedicationRow;
